import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { PredefinedTimeEntryDuration } from '/@/modules/timeentry/enums/PredefinedTimeEntryDuration';
import Lang from '/@/modules/core/app/services/Lang';

export class TimeEntryDurationSelectConfig extends FormSelectConfig {
  constructor(config = {}) {
    super({
      ...config,
      label: 'label',
      trackBy: 'value',
      placeholder: Lang.t('Time'),
      selectLabel: '',
      selected: true,
      showLabels: false
    });
  }

  getOptions(): PredefinedTimeEntryDuration[] {
    return PredefinedTimeEntryDuration.getValues();
  }
}
